import type { RouteObject } from 'react-router';
import { Goals } from './management/Goals';
import { PortfolioPage, Portfolios } from './management/Portfolios';
import { ExternalDetail, ExternalList } from './management/External';
import { CorrectiveList, CorrectivePlan, MeetingPage, Meetings, Risks } from './management/Controls';
import { Reports } from './reports/Reports';
import { AuditAdmin, EngineAdmin, SettingsAdmin, TeamsAdmin, UsersAdmin } from './admin/Admin';
import { SetupWizard } from './admin/Setup';
import { ModuleGuard } from './ModuleGuard';

/** Rutas de gestión genérica y administración del núcleo; cada pantalla de gestión exige su módulo `core.*`. */
export function coreRoutes(): RouteObject[] {
  const m = (module: string, element: React.ReactNode) => <ModuleGuard module={module}>{element}</ModuleGuard>;
  return [
    { path: 'objetivos', element: m('core.goals', <Goals />) },
    { path: 'portafolios', element: m('core.portfolios', <Portfolios />) },
    { path: 'portafolios/:portfolioId', element: m('core.portfolios', <PortfolioPage />) },
    { path: 'colaboradores', element: m('core.external', <ExternalList />) },
    { path: 'colaboradores/:engagementId', element: m('core.external', <ExternalDetail />) },
    { path: 'acciones-correctivas', element: m('core.corrective', <CorrectiveList />) },
    { path: 'acciones-correctivas/:planId', element: m('core.corrective', <CorrectivePlan />) },
    { path: 'riesgos', element: m('core.risks', <Risks />) },
    { path: 'reuniones', element: m('core.meetings', <Meetings />) },
    { path: 'reuniones/:meetingId', element: m('core.meetings', <MeetingPage />) },
    { path: 'reportes', element: <Reports /> },
    { path: 'admin/personas', element: <UsersAdmin /> },
    { path: 'admin/equipos', element: <TeamsAdmin /> },
    { path: 'admin/motor', element: <EngineAdmin /> },
    { path: 'admin/configuracion', element: <SettingsAdmin /> },
    { path: 'admin/auditoria', element: <AuditAdmin /> },
    { path: 'puesta-en-marcha', element: <SetupWizard /> },
  ];
}
